import { AxiosResponse } from "axios";
import { call, put } from "redux-saga/effects";
import api from "../../Axios/middleware";
import { failureMyCourse, successMyCourse } from "./MyCourseSlice";
import { PayloadAction } from "@reduxjs/toolkit";

// API call to fetch course details
const MyCourseApi = (action: PayloadAction<string>) => {
  return api.get(`/api/my-course/?course_id=${action.payload}`);
};

export function* MyCourseCall(action: PayloadAction<string>) {
  try {
    const response: AxiosResponse = yield call(MyCourseApi, action);
    yield put(successMyCourse(response.data));
  } catch (error) {
    yield put(failureMyCourse(error));
  }
}
